import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { useClaimTable } from "Order/Modules/Claim/Components/Hooks/useClaimsListTable";
import { useClaimFilters } from "Order/Modules/Claim/Hooks/Filter/useClaimFilters";
import { PageContainer } from "Shared/Components/Container";
import { Table } from "Shared/Components/Table";
import { Typography } from "@mui/material";

const claimsPageResource = Resources.base.claim.claimsList;

export const ClaimsPage = () => {
	const { t } = useResource();
	const filter = useClaimFilters();
	const tableOptions = useClaimTable(filter);

	return (
		<PageContainer
			title={t(claimsPageResource.title)}
			description={t(claimsPageResource.description)}
		>
			<Typography variant="h2" mb={2}>
				{t(claimsPageResource.title)}
			</Typography>
			<Table tableOptions={tableOptions} />
		</PageContainer>
	);
};
